// Development (master)
export const SERVER_URL = 'https://api.dev.coronacarecard.com';
export const STRIPE_KEY = 'pk_test_0BzKUlsNOWH8sa7kIWNgL4D200YFqSJPGi';

// Beta (stage)
// export const SERVER_URL = 'https://api.beta.coronacarecard.com';
// export const STRIPE_KEY = 'pk_test_0YdWqCGqAksTQ72OmF1bua1400sTne7wY5';

export const APP_URL = 'www.ccarecard.com';
export const GOOGLE_API_KEY = 'AIzaSyBhJv9uFwg1EzoxLEPIHUkh0oiJtB_EVTo';

export const CONTACT_EMAIL = 'hello@ccarecard.com';

export const STATUS_CLAIMED = 'Claimed';
export const STATUS_PENDING = 'Pending';
export const STATUS_ACTIVE = 'Active';

export const ALERT_BUSINESS_ACTIVE = 'business-active';
export const ALERT_BUSINESS_CLAIMED = 'business-claimed';
export const ALERT_BUSINESS_PENDING = 'business-pending';

export const FACEBOOK = 'Facebook';
export const TWITTER = 'Twitter';
export const WHATS_APP = 'WhatsApp';
export const EMAIL = 'Email';
export const COPY_LINK = 'Copy Link';
